import { render } from "./Curved.vue?vue&type=template&id=009fde46&scoped=true"
import script from "./Curved.vue?vue&type=script&lang=js"
export * from "./Curved.vue?vue&type=script&lang=js"

import "./Curved.vue?vue&type=style&index=0&id=009fde46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009fde46"]])

export default __exports__